import { 
    APPEND_NOTIFICATION_LIST,
    SET_LOADING, SET_NOTIFICATION_LIST, SET_NOTIFICATION_LIST_META,
} from "../../actions/notification/types";

const INITIAL_STATE = {
    loading: false,
    notificationList: [],
    notificationListMetaData: {
        loading: false, hasMore: true
    },
}

const NotificationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_NOTIFICATION_LIST: {
            return {
                ...state,
                notificationList: action.payload
            }
        }
        case SET_NOTIFICATION_LIST_META: {
            return {
                ...state,
                notificationListMetaData: action.payload
            }
        }
        case APPEND_NOTIFICATION_LIST: {
            return {
                ...state,
                notificationList: [ ...state.notificationList, ...action.payload]
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default NotificationReducer;